// extracted by mini-css-extract-plugin
export const ldsEllipsis = "loaderScreen-module--lds-ellipsis--1kI5I";
export const ldsEllipsis1 = "loaderScreen-module--lds-ellipsis1--1gj65";
export const ldsEllipsis2 = "loaderScreen-module--lds-ellipsis2--3Q2ZL";
export const ldsEllipsis3 = "loaderScreen-module--lds-ellipsis3--2RoWu";